import { Component } from '@angular/core';
import { KeywordsService } from 'src/app/services/lobby/keywords.service';
import { ConfigService } from '../../services/config/config.service';
import { EventsService } from '../../services/event/event.service';
import { UserSessionService } from '../../services/user-session/user-session.service';
import { Platform } from '@ionic/angular';
import { LobbyStateService } from 'src/app/services/lobbyState/lobby-state.service';
import { ScrollService } from 'src/app/services/scroll/scroll.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tab-casino',
  templateUrl: 'tab-casino.page.html',
  styleUrls: ['tab-casino.page.scss']
})

export class TabCasinoPage {
  public lobbyNameParam: string;
  public desktopPlacement: string;
  public isAuthenticated: boolean = false;
  public showLobby: boolean = false;
  public filteredCasinoGames: any;
  public showLastPlayed: boolean = false;
  public lobbyID: string;
  public isMobileApp: boolean = false;
  private authSubscription: Subscription;
  public lobbies: any[];


  constructor(
    private config: ConfigService,
    private userSessionService: UserSessionService,
    private eventsService: EventsService,
    private platform: Platform,
    private keywordsService: KeywordsService,
    private scroll: ScrollService,
    private lobbyStateService: LobbyStateService
  ) {
    this.lobbies = [];
  }

  ngOnInit() {

    this.updateAuthentication();

    this.isMobileApp = this.platform.is('capacitor');

    this.eventsService.subscribe('casino:lobby', (value) => {
      this.showLobby = value;
    });

    this.eventsService.publish('casino:lobby', true);
  }

  subscribeToCustomer(subscription) {
    subscription.subscribe(() => {
      this.updateAuthentication();
    });
  }

  onContainerScroll(e) {
    if (this.isMobileApp)
      this.scroll.setScrollPosition((e))
  }

  /*updateAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }*/

  updateAuthentication() {
    // Subscribe to the authentication status observable
    this.authSubscription = this.userSessionService.getCustomer().subscribe((customer) => {
      this.isAuthenticated = !!customer;
    });
}

  checkClientApp() {
    if (this.config.getClientApp() == 'WebCasinoPA-3.0') {
      this.lobbyID = "CASINOPAMAIN";
    } else {
      this.lobbyID = "CASINONJMAIN";
    }
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }

}
